module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-how-heat-press-623b3007cf2c3f905972d1dabddb1c57.svg";